import styled from 'styled-components';

export const ScrollableStyled = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  scrollbar-width: thin;
  padding: 16px 0;
  .scroll-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const FilterDiv = styled.div`
  // padding-bottom: 8px;
  height: max-content;
  overflow-x: auto;
  position: relative;

  // Removed z-index and transform hacks that were causing white box overlay on iOS
  // These GPU acceleration "fixes" can create unexpected rendering layers

  // hide scrollbar
  ::-webkit-scrollbar {
    /* Hide scrollbar for Chrome, Safari and Opera */
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
